import React, {useContext} from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import {makeStyles} from '@material-ui/core/styles';

import * as ModalConstants from 'components/modals/modal-constants';
import {ModalContext} from 'components/modals/modal-context';

import type {DialogContentProps} from '@material-ui/core/DialogContent';
import type {Theme} from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles<Theme, Pick<Props, 'isOverflowVisible'>>((theme) => {
    const dialogContentRoot = {
        ...theme.typography.componentS,
        color: theme.palette.text.secondary,
        overflow: ({isOverflowVisible}) => (isOverflowVisible ? 'visible' : 'auto'),
    };

    return {
        rootSmall: {
            ...dialogContentRoot,
            paddingLeft: ModalConstants.modalMarginSm,
            paddingRight: ModalConstants.modalMarginSm,
        },
        rootMedium: {
            ...dialogContentRoot,
            paddingLeft: ModalConstants.modalMarginMd,
            paddingRight: ModalConstants.modalMarginMd,
        },
        rootLarge: {
            ...dialogContentRoot,
            paddingLeft: ModalConstants.modalMarginLg,
            paddingRight: ModalConstants.modalMarginLg,
        },
    };
});

export type Props = Pick<DialogContentProps, 'children'> & {
    isOverflowVisible?: boolean;
};

const ModalContent = (props: Props) => {
    const {children, isOverflowVisible = false} = props;
    const classes = useStyles({isOverflowVisible});
    const {size} = useContext(ModalContext);

    let root: string;
    switch (size) {
        case 'small':
            root = classes.rootSmall;
            break;
        case 'large':
            root = classes.rootLarge;
            break;
        case 'medium':
        default:
            root = classes.rootMedium;
            break;
    }

    return <DialogContent classes={{root}}>{children}</DialogContent>;
};

export default ModalContent;
